// scheduling/components/SchedStatBar.jsx
// Generic 4-item stat bar shared by every dashboard view (staff + manager use the
// same .sched-statbar layout). Callers pass computed { label, value, color } items.

export default function SchedStatBar({ items }) {
  return (
    <div className="sched-statbar">
      {items.map((it, i) => (
        <div key={i} className="sched-statbar-item">
          <span className="sched-statbar-value" style={{ color: it.color }}>{it.value}</span>
          <span className="sched-statbar-label">{it.label}</span>
        </div>
      ))}
    </div>
  );
}
